import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(theme => ({
  formContainer: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%'
  },
  helper: {
    marginTop: theme.spacing(1)
  },
  emailBodyRenderer: {
    flexGrow: '1',
    width: '100%',
    border: `1px solid ${theme.palette.customColors.iconInactive}`,
    borderRadius: theme.spacing(0.5),
    padding: theme.spacing(1.5),
    overflowY: 'scroll',
    marginBottom: theme.spacing(1)
  }
}));
